<div class="global-logout-container">
  <div class="global-logout-card">
    <img src="assets/vectors/RegTrackLogo.svg" alt="RegTrack" class="global-logout-logo" />
    <div class="global-logout-spinner"></div>
    <p class="global-logout-message">{{ 'compliance.global_logout.logging_you_out' | translate }}&hellip;</p>
    <p class="global-logout-sub">{{ 'compliance.global_logout.please_wait_session_clearing' | translate }}</p>
  </div>
</div>
